import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';
import { RequestStatus } from '../../../adapters/xhr/RequestStatus';
import { EnableSecurity } from '../../../config/appSettings';
import { AppLocalStorage, AppLocalStorageItems } from '../../../helpers/localStorageHelper';
import { verifyUserCredentials,setUserAuth } from '../../../store/auth/authSlice';
import { getResourceData } from '../../../store/resource/resourceSlice';
import { setCurrentTenant } from '../../../store/tenant/tenantSlice';
import { PageLoader } from '../../loader/pageLoader';
import { Banner } from '../banner';
import { Footer } from '../footer';
import { Header } from '../header';
import { getGaiConfig } from '../../../store/gai/gaiSlice';
import { usePermissions } from '../../../hooks/usePermissions';
import { getChartConfig } from '../../../store/charts/chartSlice';
import { ProjectBanner } from '../../Projects/projectBanner';
export function SecureLayout() {
    const userInfo = useSelector(store => store.auth.userInfo);
    const isPageLoading = useSelector(store => store.loader.isPageLoading);
    const location = useLocation();
    const dispatch = useDispatch();
    const [isMounted, setIsMounted] = useState(true);
    const [isResourceLoaded, setIsResourceLoaded] = useState(false)
    window.slbConfig.userName = userInfo.email;
    window.slbConfig.rcPermissions.isCurrentUserAdmin = usePermissions().FullControl;
    const slbSearchConfig = window.slbConfig;
    React.useEffect(() => {
        let data = {
            clientId: slbSearchConfig.accountId,
            projectId: slbSearchConfig.projectId
        }
        let promise
        if (EnableSecurity && !userInfo.isAuthenticated) {
            promise = dispatch(verifyUserCredentials()).then((res) => {
                dispatch(setCurrentTenant(res?.payload?.data?.tenant))
            })
        }
        dispatch(getGaiConfig())
        dispatch(getChartConfig())
        dispatch(getResourceData(data)).then(res => {
            if (isMounted) {
                setIsResourceLoaded(true);
            }
        })
        
        const isLogged = sessionStorage.getItem("logged"); 
        if(isLogged ==null || !isLogged || isLogged =="false"){
           AppLocalStorage.clearLocalStorage();
           window.location= "/signin";
        }
        
        // window.addEventListener("beforeunload", (ev) => 
        // {  
        //     ev.preventDefault();
        //     sessionStorage.setItem("logged", false);

        // });
 
        return () => {
            if (promise && typeof promise.abort === 'function') {
                promise.abort()
            }
            setIsMounted(false)
        }
    }, [])

    if(isPageLoading){
        return <PageLoader />
    }
      

    if (EnableSecurity) {
        if ((!userInfo.isAuthenticated || userInfo.tokenExpired) && (userInfo.status === RequestStatus.Fulfilled || userInfo.status === RequestStatus.Rejected)) {
            //AppLocalStorage.setStorageItem(AppLocalStorageItems.RedirectUrl, location.pathname)
            return <Navigate to="/signin" state={{ from: location.pathname, noPermission : userInfo.noPermission }} replace />;
        }
        else if (!userInfo.isAuthenticated && (userInfo.status === RequestStatus.Idle || userInfo.status === RequestStatus.Pending)) {
            return <div>
                <span></span>
                <PageLoader />
            </div>
        }
    }
    const pathName = window.location.pathname
    if ((!EnableSecurity || userInfo.isAuthenticated) && isResourceLoaded)
        return <div>
            <Header />
         {/* {pathName != "/search" && <Banner />} */}
         {pathName !== "/search" && pathName !== "/projects" && <Banner />}
         {pathName == "/projects" && <ProjectBanner />}
            <div className='body_check'> <Outlet />
            </div>
            <Footer />
        </div>
}